(function () {
  function getScope(checkbox) {
    return checkbox.closest('form, cart-drawer') || document;
  }

  function updateScope(scope) {
    if (!scope) return;
    var checkboxes = scope.querySelectorAll('[data-legal-checkbox]');
    if (!checkboxes.length) return;

    var allChecked = Array.prototype.every.call(checkboxes, function (checkbox) {
      return checkbox.checked;
    });

    var buttonsWrapper = scope.querySelector('[data-cart-checkout-buttons]');
    if (buttonsWrapper) {
      buttonsWrapper.classList.toggle('cart__buttons--disabled', !allChecked);
    }

    return allChecked;
  }

  function showError(scope, visible) {
    var error = scope.querySelector('[data-legal-checkbox-error]');
    if (error) {
      error.classList.toggle('legal-checkbox-error--visible', visible);
    }
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-legal-checkbox]')) return;
    var scope = getScope(event.target);
    var allChecked = updateScope(scope);
    showError(scope, false);
    if (allChecked === false) {
      showError(scope, true);
    }
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var checkboxes = form.querySelectorAll('[data-legal-checkbox]');
      if (!checkboxes.length) return;

      var allChecked = Array.prototype.every.call(checkboxes, function (checkbox) {
        return checkbox.checked;
      });

      if (!allChecked) {
        event.preventDefault();
        showError(form, true);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-legal-checkbox]').forEach(function (checkbox) {
      updateScope(getScope(checkbox));
    });
  });
})();
